/**
 * 接力生态看板 mock 数据（补涨分析页 UI 联调用）
 * 后续替换为接口：GET /api/.../relay-ecology?date=YYYY-MM-DD&window=20
 */

/** @typedef {'NORMAL'|'S'|'S_PLUS'} SoilState */
/** @typedef {'LOW'|'MID'|'HIGH'|null} Level */

/**
 * @typedef {Object} RelayEcologyPoint
 * @property {string} date
 * @property {number} score 主动分
 * @property {number} premium 隔夜溢价 %
 * @property {number} sealRate 封板率 %
 * @property {SoilState} soilState
 * @property {string} soilLabel
 * @property {string} soilDesc
 * @property {Level} rewardLevel
 * @property {Level} supportLevel
 */

/**
 * @typedef {Object} RelayEcologySummary
 * @property {number} normalCount
 * @property {number} sCount
 * @property {number} sPlusCount
 * @property {number} daysSinceLastSPlus
 * @property {number} avgSPlusGapDays
 * @property {{ s: number, sPlus: number }} recent20D
 */

/** @type {RelayEcologyPoint[]} */
const BASE_SERIES = [
  { date: '2024-08-10', score: 58, premium: 28.4, sealRate: 16.2, soilState: 'NORMAL', soilLabel: '', soilDesc: '常规接力环境，暂无特殊土壤信号', rewardLevel: 'MID', supportLevel: 'MID' },
  { date: '2024-08-12', score: 55, premium: 26.1, sealRate: 15.8, soilState: 'NORMAL', soilLabel: '', soilDesc: '常规接力环境，暂无特殊土壤信号', rewardLevel: 'LOW', supportLevel: 'MID' },
  { date: '2024-08-13', score: 61, premium: 32.5, sealRate: 19.1, soilState: 'S', soilLabel: '主升土壤', soilDesc: '奖励与广度偏强，主升土壤候选', rewardLevel: 'HIGH', supportLevel: 'MID' },
  { date: '2024-08-14', score: 59, premium: 30.2, sealRate: 17.4, soilState: 'NORMAL', soilLabel: '', soilDesc: '常规接力环境，暂无特殊土壤信号', rewardLevel: 'MID', supportLevel: 'LOW' },
  { date: '2024-08-15', score: 63, premium: 34.8, sealRate: 20.2, soilState: 'NORMAL', soilLabel: '', soilDesc: '常规接力环境，暂无特殊土壤信号', rewardLevel: 'HIGH', supportLevel: 'LOW' },
  { date: '2024-08-16', score: 57, premium: 27.6, sealRate: 14.9, soilState: 'NORMAL', soilLabel: '', soilDesc: '常规接力环境，暂无特殊土壤信号', rewardLevel: 'MID', supportLevel: 'MID' },
  { date: '2024-08-19', score: 64, premium: 36.1, sealRate: 21.5, soilState: 'S', soilLabel: '主升土壤', soilDesc: '奖励与广度偏强，主升土壤候选', rewardLevel: 'HIGH', supportLevel: 'HIGH' },
  { date: '2024-08-20', score: 60, premium: 29.4, sealRate: 18.0, soilState: 'NORMAL', soilLabel: '', soilDesc: '常规接力环境，暂无特殊土壤信号', rewardLevel: 'MID', supportLevel: 'MID' },
  { date: '2024-08-21', score: 52, premium: 22.8, sealRate: 12.4, soilState: 'NORMAL', soilLabel: '', soilDesc: '常规接力环境，暂无特殊土壤信号', rewardLevel: 'LOW', supportLevel: 'LOW' },
  { date: '2024-08-22', score: 54, premium: 24.5, sealRate: 13.7, soilState: 'NORMAL', soilLabel: '', soilDesc: '常规接力环境，暂无特殊土壤信号', rewardLevel: 'LOW', supportLevel: 'MID' },
  { date: '2024-08-23', score: 56, premium: 25.9, sealRate: 15.1, soilState: 'NORMAL', soilLabel: '', soilDesc: '常规接力环境，暂无特殊土壤信号', rewardLevel: 'MID', supportLevel: 'MID' },
  { date: '2024-08-26', score: 68, premium: 41.2, sealRate: 18.6, soilState: 'S_PLUS', soilLabel: '冰点修复', soilDesc: '处于冰点后，情绪修复中', rewardLevel: null, supportLevel: null },
  { date: '2024-08-27', score: 65, premium: 38.4, sealRate: 22.1, soilState: 'NORMAL', soilLabel: '', soilDesc: '常规接力环境，暂无特殊土壤信号', rewardLevel: 'HIGH', supportLevel: 'MID' },
  { date: '2024-08-28', score: 62, premium: 33.0, sealRate: 19.8, soilState: 'NORMAL', soilLabel: '', soilDesc: '常规接力环境，暂无特殊土壤信号', rewardLevel: 'MID', supportLevel: 'HIGH' },
  { date: '2024-08-29', score: 58, premium: 29.7, sealRate: 17.2, soilState: 'NORMAL', soilLabel: '', soilDesc: '常规接力环境，暂无特殊土壤信号', rewardLevel: 'MID', supportLevel: 'MID' },
  { date: '2024-08-30', score: 51, premium: 21.3, sealRate: 11.8, soilState: 'NORMAL', soilLabel: '', soilDesc: '常规接力环境，暂无特殊土壤信号', rewardLevel: 'LOW', supportLevel: 'LOW' },
  { date: '2024-09-02', score: 53, premium: 23.6, sealRate: 13.2, soilState: 'NORMAL', soilLabel: '', soilDesc: '常规接力环境，暂无特殊土壤信号', rewardLevel: 'LOW', supportLevel: 'MID' },
  { date: '2024-09-03', score: 57, premium: 28.0, sealRate: 16.5, soilState: 'NORMAL', soilLabel: '', soilDesc: '常规接力环境，暂无特殊土壤信号', rewardLevel: 'MID', supportLevel: 'MID' },
  { date: '2024-09-04', score: 60, premium: 31.5, sealRate: 18.9, soilState: 'NORMAL', soilLabel: '', soilDesc: '常规接力环境，暂无特殊土壤信号', rewardLevel: 'MID', supportLevel: 'HIGH' },
  { date: '2024-09-05', score: 55, premium: 33.1, sealRate: 24.7, soilState: 'S', soilLabel: '主升土壤', soilDesc: '奖励与广度偏强，主升土壤候选', rewardLevel: 'HIGH', supportLevel: 'MID' }
]

/**
 * @param {string} [selectedDate]
 * @returns {{ series: RelayEcologyPoint[], summary: RelayEcologySummary, candidate: { title: string, subtitle: string, date: string } }}
 */
export function getRelayEcologyMock(selectedDate) {
  const series = BASE_SERIES.map((p) => ({ ...p }))
  const sCount = series.filter((p) => p.soilState === 'S').length
  const sPlusCount = series.filter((p) => p.soilState === 'S_PLUS').length
  const normalCount = series.length - sCount - sPlusCount

  const activeIdx = resolveActiveIndex(series, selectedDate)
  const daysSinceLastSPlus = calcDaysSinceLastSPlus(series, activeIdx)
  const avgSPlusGapDays = calcAvgSPlusGap(series)

  return {
    series,
    summary: {
      normalCount,
      sCount,
      sPlusCount,
      daysSinceLastSPlus,
      avgSPlusGapDays,
      recent20D: { s: sCount, sPlus: sPlusCount }
    },
    candidate: {
      title: 'S｜主升土壤',
      subtitle: 'Research Candidate',
      date: selectedDate || series[series.length - 1].date
    }
  }
}

/**
 * @param {RelayEcologyPoint[]} series
 * @param {string} [selectedDate]
 */
export function resolveActiveIndex(series, selectedDate) {
  if (!series.length) return -1
  if (selectedDate) {
    const i = series.findIndex((p) => p.date === selectedDate)
    if (i >= 0) return i
  }
  return series.length - 1
}

/**
 * @param {RelayEcologyPoint[]} series
 * @param {number} activeIdx
 */
export function calcDaysSinceLastSPlus(series, activeIdx) {
  if (activeIdx < 0) return null
  let last = -1
  for (let i = 0; i <= activeIdx; i++) {
    if (series[i].soilState === 'S_PLUS') last = i
  }
  if (last < 0) return null
  return activeIdx - last
}

/**
 * @param {RelayEcologyPoint[]} series
 */
export function calcAvgSPlusGap(series) {
  const idxs = []
  series.forEach((p, i) => {
    if (p.soilState === 'S_PLUS') idxs.push(i)
  })
  if (idxs.length < 2) return 8.5 // mock fallback matching design
  let sum = 0
  for (let i = 1; i < idxs.length; i++) sum += idxs[i] - idxs[i - 1]
  return Math.round((sum / (idxs.length - 1)) * 10) / 10
}

/**
 * @param {SoilState} state
 */
export function getSoilDisplay(state, label) {
  if (state === 'S_PLUS') {
    return {
      key: 'S_PLUS',
      short: 'S+',
      full: label || '冰点修复',
      title: `当前土壤：S+ ${label || '冰点修复'}`,
      tone: 'splus'
    }
  }
  if (state === 'S') {
    return {
      key: 'S',
      short: 'S',
      full: label || '主升土壤',
      title: `当前土壤：S ${label || '主升土壤'}`,
      tone: 's'
    }
  }
  return {
    key: 'NORMAL',
    short: 'NORMAL',
    full: '常规',
    title: '当前土壤：NORMAL',
    tone: 'normal'
  }
}

export const RELAY_ECOLOGY_API_FIELDS = {
  endpoint: 'GET /api/relay-ecology?date=YYYY-MM-DD&window=20',
  seriesItem: [
    'date',
    'score',
    'premium',
    'sealRate',
    'soilState', // NORMAL | S | S_PLUS
    'soilLabel',
    'soilDesc',
    'rewardLevel', // LOW | MID | HIGH | null
    'supportLevel' // LOW | MID | HIGH | null
  ],
  summary: [
    'normalCount',
    'sCount',
    'sPlusCount',
    'daysSinceLastSPlus',
    'avgSPlusGapDays',
    'recent20D.s',
    'recent20D.sPlus'
  ],
  candidate: ['title', 'subtitle', 'date']
}
